import styled from "styled-components";

export const Separator = styled.div`
    height: 30px;
`;
